module.exports = __webpack_public_path__ + "house.png";